module.exports = {
  ...require('./spellImageCollection_AI'),
  ...require('./spellImageCollection_EGTW'),
  ...require('./spellImageCollection_FTD'),
  ...require('./spellImageCollection_PHB'),
  ...require('./spellImageCollection_TCoE'),
  ...require('./spellImageCollection_XGTE'),
}
